import React, { Component } from 'react';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from "react-router-dom";
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import {
  DetailContainer,
  Description,
  FormContainer
} from './OurStyleStyles';
import ProgressBar from '../../components/progressBar/ProgressBar';
import DecorationNavigation from '../../components/decorationNavigation/DecorationNavigation';
import {
  findPageByTag,
  findPageByID
} from '../../infra/services/utils/PageInfo';
import {
  findPrevChapter
} from '../../infra/services/utils/PageNavigation';
import YourSuggestionsForm from './YourSuggestionsForm';
import { GetCurrentInspirations, UpdateAllOurSuggestions } from '../../infra/requests/OurStyleRequests';
import SaveButton from '../../components/buttons/SaveButton';
import { SpinLoading } from "../../styles/BasicStyles";
import {
  processClosed
} from '../../infra/services/utils/BlockAnswers';

const limitSuggestions = 10;
const sectionTag = 'STYLE';
const chapterId = '5e42e53429196b814f617d30';
const returnURL = '/our-style';
const nextUrl = '/our-day';
const nextName = 'OUR_DAY';

class YourSuggestions extends Component {
  state = {
    chapter: undefined,
    prevChapter: undefined,
    currentSuggestions: undefined,
    isProcessClosed: undefined,
    ready: false
  };

  componentDidMount() {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    document.body.style.overflowY = 'auto';

    this.updateSection();
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps?.id) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      document.body.style.overflowY = 'auto';

      this.updateSection();
    }
  }

  updateSection = async () => {
    const { weddingInfo, ourStyleInfo } = this.props;

    const { chapters } = findPageByTag(ourStyleInfo, sectionTag);
    const chapter = findPageByID(chapters, chapterId);
    const prevChapter = findPrevChapter(ourStyleInfo, chapter.section, chapters, chapter._id);
    const isProcessClosed = processClosed(weddingInfo.blockDate);

    const resultInspirations = await GetCurrentInspirations();
    let currentSuggestions = [];

    if (resultInspirations.success) {
      currentSuggestions = resultInspirations.data;
    }

    this.setState({
      chapter,
      prevChapter,
      currentSuggestions,
      isProcessClosed,
      ready: true
    });
  };

  onSubmit = async (values) => {
    try {
      this.setState({ loading: true });

      const { history } = this.props;
      
      const result = await UpdateAllOurSuggestions(values);
      if (result?.success) {
        history.push(nextUrl);
      }   

      this.setState({ loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  render() {
    const { translate, activeLanguage, history, handleSubmit } = this.props;
    const { chapter, prevChapter, currentSuggestions, isProcessClosed, ready } = this.state;

    if (!ready) return <SpinLoading />;

    return (
      <React.Fragment>
        <ProgressBar type='total' num_questions={1} num_answers={currentSuggestions.length > 0 ? 1 : 0} />
        <DecorationNavigation
          returnUrl={returnURL}
          mainCategory={translate('OUR_STYLE')}
          currentQuestion={chapter.name[activeLanguage?.code]}
          currentQuestionUrl={`${returnURL}/${chapterId}`}
          nextQuestion={translate(nextName)}
          nextQuestionUrl={nextUrl}
          prevQuestion={prevChapter?.name[activeLanguage?.code]}
          prevQuestionUrl={`${returnURL}/${prevChapter?._id}`}
        />
        <DetailContainer>
          <Description dangerouslySetInnerHTML={{ __html: chapter.description && chapter.description[activeLanguage?.code] }} />
          <FormContainer onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              name='suggestions'
              component={YourSuggestionsForm}
              currentSuggestions={currentSuggestions}
              limitSuggestions={limitSuggestions}
              isProcessClosed={isProcessClosed}
              onSuggestionSaved={this.updateSection}
            />
            <SaveButton
              htmlType='submit'
              text={translate('SAVE_CONTINUE')}
              textMobile={translate('SAVE')}
              withBackground={true}
            />
          </FormContainer>
        </DetailContainer>
      </React.Fragment>
    );
  }
}

YourSuggestions = reduxForm({
  form: 'section_form'
})(YourSuggestions);

const mapStateToProps = state => ({
  ourStyleInfo: state.wedding.structure,
  weddingInfo: state.wedding.wedding
});

export default connect(mapStateToProps)(withLocalize(withRouter(YourSuggestions)));